import { render, staticRenderFns } from "./application-layout.vue?vue&type=template&id=5947e2a8&scoped=true"
import script from "./application-layout.vue?vue&type=script&lang=js"
export * from "./application-layout.vue?vue&type=script&lang=js"
import style0 from "./application-layout.vue?vue&type=style&index=0&id=5947e2a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5947e2a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5947e2a8')) {
      api.createRecord('5947e2a8', component.options)
    } else {
      api.reload('5947e2a8', component.options)
    }
    module.hot.accept("./application-layout.vue?vue&type=template&id=5947e2a8&scoped=true", function () {
      api.rerender('5947e2a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/application-standalone/components/layout/application-layout.vue"
export default component.exports